module.exports = __webpack_public_path__ + "static/media/drag-indicator.6dfe47c9.svg";